export default __webpack_public_path__ + "static/media/profile-edit.4c0d1b39.svg";